// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 部署类型 枚举类
 * 部署类型
 */
export enum EnumDeployType {
  /** 云部署 : 云部署 */
  Cloud = 1,
  /** 私有化云部署 : 私有化云部署 */
  PrivateCloud = 2,
  /** 私有化部署 : 私有化部署 */
  Private = 4
}

/**
 * 部署类型 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumDeployTypeMD {
  private static items = [
    new EnumItemMD('Cloud', 1, '云部署', '云部署'),
    new EnumItemMD('PrivateCloud', 2, '私有化云部署', '私有化云部署'),
    new EnumItemMD('Private', 4, '私有化部署', '私有化部署')
  ];

  static getItem(enumItem: EnumDeployType) {
    return this.items.find(item => item.name === EnumDeployType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
